<template>
  <div>
    <div class="mt-2 font-weight-bold">
      {{ $t('forms.action.PayerActivateInfo') }}
    </div>
    <hr>

    <div class="row no-gutters align-items-center mt-2 rule-row">
      <div class="col-4">
        <span class="pr-2 mb-0 small text-secondary">
          Email
        </span>
      </div>
      <div class="col-8 pr-1">
        <FieldOrRule
          v-model="mapping.email"
          :layout="layout"
        />
      </div>
    </div>
    <div class="row no-gutters align-items-center mt-2 rule-row">
      <div class="col-4">
        <span class="pr-2 mb-0 small text-secondary">
          {{ $t('login.phoneNumber') }}
        </span>
      </div>
      <div class="col-8 pr-1">
        <FieldOrRule
          v-model="mapping.phone"
          :layout="layout"
        />
      </div>
    </div>

    <hr>
    <ActionEnabled
      v-model="mapping.actionRule"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionEnabled from './ActionEnabled';
import FieldOrRule from './FieldOrRule';

export default {
  props: {
    metadata: Object,
    layout: Array,
  },
  data: () => ({
    activate: false,
    mapping: {},
  }),
  components: {
    FieldOrRule,
    ActionEnabled,
  },
  computed: {
    ...mapGetters([
      'properties',
      'userGroups',
      'payersPropertyTypes',
    ]),
    model() {
      return {
        actionRule: this.mapping.actionRule,
        email: this.mapping.email,
        phone: this.mapping.phone,
      };
    },
  },
  watch: {
    model: {
      deep: true,
      handler(newVal) {
        this.$emit('update:metadata', newVal);
      },
    },
  },
  created() {
    const model = this.metadata;

    this.$set(this.mapping, 'actionRule', model.actionRule);
    this.$set(this.mapping, 'email', model.email);
    this.$set(this.mapping, 'phone', model.phone);
  },
};
</script>

<style lang="scss" scoped>
.rule-row {
  padding-left: 5px;

  &:hover {
    background-color: #fafafa;
  }
}
</style>
